import React, {useState} from "react";
import CvEdit from "./CvEdit";
import {getDescription, getHelp} from "./CvParser";

const CvDetail = ({data, activeItems}) => {
    const {number = 0, id = 0, type = "-"} = data;

    const containerstyle = {
        backgroundColor: '#85afd9',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid black',
        margin: '5px',
    }

    const headerstyle = {
        fontSize: '15px',
        color: 'black',
        margin: '5px',
        marginTop: '10px',
    }

    const cvnumberstyle = {
        fontSize: '15px',
        color: 'black',
        margin: '5px',
        fontWeight: 'bold',
    }

    const helpstyle = {
        fontSize: '12px',
        color: 'black',
        margin: '5px',
        marginLeft: '10px',
    }

    const help = getHelp(data)

    //const number = data?.number
    return (
        <div style={containerstyle}>
            <div style={headerstyle}><span style={cvnumberstyle}>{number}</span>{getDescription(data)}</div>
            {help && <div style={helpstyle}>{help}</div>}
            <CvEdit key={id} data={data} activeItems={activeItems}/>
        </div>
    )
}

export default CvDetail;
